<div class="flex-shrink-0">
  <input type="file" #file placeholder="Seleccionar Planilla" [accept]="acceptFile" (change)="uploadFile(file.files)"
    style="display:none;">

  <button type="button" class="btn btn-sm btn-outline-primary btn-icon w-100" (click)="file.click()"><i
      class="ri-contacts-book-upload-line fs-5"></i>
      <span class="mx-5">{{label}}</span>
  </button>
  @for (item of filesToUpload; track item) {
  <label class="badge bg-body-secondary rounded-pill border border-success text-success w-100 mt-2">{{ item.name
    }}</label>
  }
</div>